import React, { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { 
  ArrowRightOnRectangleIcon, 
  UserCircleIcon,
  ShieldCheckIcon 
} from '@heroicons/react/24/outline';

const Header = () => {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [redirectToHome, setRedirectToHome] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");

    if (storedUserData) {
      const userData = JSON.parse(storedUserData);
      setName(userData.name);
      setUsername(userData.username);
      setRole(userData.role);

      if (userData.role !== "admin" && userData.role !== "emp") {
        setRedirectToHome(true);
      }
    } else {
      setRedirectToHome(true);
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/admin-login");
  };

  if (redirectToHome) {
    return <Navigate to="/" />;
  }

  return (
    <header className="h-20 bg-white border-b border-gray-200 shadow-sm">
      <div className="h-full flex items-center justify-between px-8">
        {/* Logo Section */}
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 rounded-xl overflow-hidden shadow-md ring-2 ring-blue-100">
            <img
              src="/assets/logo.jpeg"
              alt="Logo"
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-800">Exam Portal</h1>
            <p className="text-xs text-gray-500">Management System</p>
          </div>
        </div>

        {/* User Info & Actions */}
        <div className="flex items-center space-x-6">
          {/* User Details */}
          <div className="hidden md:flex items-center space-x-4 bg-gray-50 rounded-xl px-5 py-3 border border-gray-200">
            <div className="flex items-center space-x-2">
              <UserCircleIcon className="h-5 w-5 text-blue-600" />
              <div>
                <p className="text-xs text-gray-500 font-medium">Name</p>
                <p className="text-sm text-gray-800 font-semibold">{name}</p>
              </div>
            </div>
            
            <div className="w-px h-8 bg-gray-300"></div>
            
            <div className="flex items-center space-x-2">
              <div>
                <p className="text-xs text-gray-500 font-medium">ID</p>
                <p className="text-sm text-gray-800 font-semibold">{username}</p>
              </div>
            </div>

            <div className="w-px h-8 bg-gray-300"></div>
            
            <div className="flex items-center space-x-2">
              <ShieldCheckIcon className="h-5 w-5 text-green-600" />
              <div>
                <p className="text-xs text-gray-500 font-medium">Role</p>
                <p className={`text-sm font-bold capitalize ${
                  role === 'admin' ? 'text-red-600' : 'text-blue-600'
                }`}>
                  {role}
                </p>
              </div>
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="flex items-center space-x-2 px-5 py-2.5 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-xl hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5" />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
